import React from 'react'
import Heading from '@react/react-spectrum/Heading'
import Pattern from '../Nav/Pattern'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'

export default function SelectAPattern ({ group, patterns }) {
    return (
        <React.Fragment>
            <Heading variant="subtitle2">{__('smartobject_nav_selectpattern')}:</Heading>
            {patterns.map(({ url, action }) =>
                <Pattern action={action} key={action} group={group} src={url} alt={`${__('smartobject_nav_selectpattern')} for ${action}`} />
            )}
        </React.Fragment>
    )
}
